import MessageStore from './MessageStore';

export default MessageStore;